import React, { Component } from 'react';
import { Button, Modal, Form, Spin, Input } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { actions } from "store";
import { FormItem, TranslationFormItem } from 'utils/form_helpers';

import styles from "./form.module.css";


class CountryForm extends Component {
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const { actions, geo_country } = this.props;
                const instance = geo_country.editObject;

                let data = Object.assign({}, values);
                if (instance && instance.id) {
                    data.id = instance.id;
                }
                actions.geoCountryUpdate({ data });
            }
        });
    };

    close = () => {
        const { actions } = this.props;
        actions.geoCountryShowEditForm({ show: false });
    };

    render() {
        const { form, geo_country } = this.props;
        const { showEditForm, updateStatus, editObject } = geo_country;
        const instance = editObject;

        const error = updateStatus.error || {};
        const errorData = error.data || {};

        const isLoading = geo_country.updateStatus.isLoading;

        return (
            <Modal
                visible={showEditForm}
                title="Редактирование страны"
                onCancel={this.close}
                maskClosable={false}
                footer={[
                    <Button key="cancel" onClick={this.close} disabled={isLoading}>Отмена</Button>,
                    <Button key="submit" type="primary" loading={isLoading} onClick={this.handleSubmit}>
                        Сохранить
                    </Button>,
                ]}
            >
                <Spin spinning={isLoading}>
                    <Form onSubmit={this.handleSubmit}>
                        {errorData.non_field_errors &&
                        <div className={styles.error}>{errorData.non_field_errors}</div>}

                        <TranslationFormItem
                            form={form}
                            instance={instance}
                            name="name"
                            label="Название"
                            required={true}
                            errorData={errorData}
                        />

                        <FormItem
                            form={form}
                            instance={instance}
                            name="code"
                            label="Код"
                            required={true}
                            errorData={errorData}

                        >
                            <Input size="large"/>
                        </FormItem>

                        <FormItem
                            form={form}
                            instance={instance}
                            name="slug"
                            label="Путь"
                            required={true}
                            errorData={errorData}

                        >
                            <Input size="large"/>
                        </FormItem>
                    </Form>
                </Spin>
            </Modal>
        );
    }
}


const WrappedCountryForm = Form.create()(CountryForm);

function mapStateToProps(state) {
    return {
        auth: state.auth,
        geo_country: state.geo_country,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, actions.geo_country), dispatch),
        dispatch: dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WrappedCountryForm);

